module.exports = __webpack_public_path__ + "img/resteaze-components-tall.575cf0e0.png";